import { z } from 'zod';

export type Document = z.infer<typeof documentSchema>;
export type LegacyPreviewPage = z.infer<typeof legacyPreviewPageSchema>;
export type Rubricate = z.infer<typeof rubricateSchema>;
export type Summary = z.infer<typeof summarySchema>;

export const documentSchema = z.object({
  key: z.string(),
  name: z.string(),
  deadlineAt: z.string(),
  originalUrl: z.string(),
  pdfUrl: z.string(),
  refusable: z.boolean().default(false),
  totalSignatures: z.number(),
  totalSigned: z.number(),
  forcePreviewPages: z.boolean().default(false),
});

export const documentShowResponseSchema = z.object({
  document: documentSchema,
});

export const documentListResponseSchema = z.object({
  documents: z.array(documentSchema),
});

export const summarySchema = z.object({
  summary: z.string(),
  category: z.string(),
  reference: z.string(),
});

export const documentSummariesSchema = z.object({
  summary: z.array(summarySchema),
});

const legacyPreviewPageSchema = z.object({
  imageUrl: z.string(),
});

export const legacyPreviewSchema = z.object({
  pages: z.array(legacyPreviewPageSchema),
});

export const rubricateSchema = z.object({
  initials: z.string().nullable(),
  key: z.string(),
  manuscript: z.string().nullable(),
  expireAt: z.string(),
});

export const rubricatesSchema = z.object({
  rubricate: rubricateSchema,
});
